import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import { CustomModal, Loading, ConfirmDialog, CustomDataTableHeader } from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import * as AnalistaEntregaHttp from '../../../../services/api/https/registration/analista-entrega.http'

const ModalCadastrarAnalista = ({ show, onClose, onSuccess, loggedUserId, dispatch }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [usuarios, setUsuarios] = useState([])
  const [globalFilter, setGlobalFilter] = useState('')
  const [selectedUser, setSelectedUser] = useState(null)
  const [showConfirm, setShowConfirm] = useState(false)
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    async function fetchUsuarios() {
      try {
        const data = await AnalistaEntregaHttp.getUsuariosElegiveis(loggedUserId)
        setUsuarios(data)
      } catch (error) {
        dispatch(showMessageBox(null, error))
      } finally {
        setIsLoading(false)
      }
    }
    if (show) fetchUsuarios()
  }, [show, loggedUserId, dispatch])

  const handleRowSelect = (e) => {
    setSelectedUser(e.value)
    setShowConfirm(true)
  }

  const handleConfirmYes = async () => {
    if (isSaving) return
    setIsSaving(true)
    try {
      const result = await AnalistaEntregaHttp.cadastrarAnalista(selectedUser.id, loggedUserId)
      dispatch(showMessageBox('Analista cadastrado com sucesso'))
      setShowConfirm(false)
      onSuccess({
        analista_id: result.id,
        user_id: selectedUser.id,
        analista_name: selectedUser.name,
        tp_ids: selectedUser.tp_ids || [],
      })
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      setIsSaving(false)
    }
  }

  const handleConfirmNo = () => {
    setShowConfirm(false)
    setSelectedUser(null)
  }

  return (
    <React.Fragment>
      <CustomModal
        header="Cadastrar usuário como analista"
        isVisible={show}
        onClose={onClose}
        width="min(70vw, 900px)"
        contentStyle={{ overflowY: 'auto', maxHeight: '70vh' }}
      >
        <p style={{ marginBottom: 16 }}>
          Selecione o usuário que deseja cadastrar como analista:
        </p>

        {isLoading ? (
          <Loading size="md" />
        ) : (
          <DataTable
            value={usuarios}
            selectionMode="single"
            onSelectionChange={handleRowSelect}
            paginator
            rows={10}
            globalFilter={globalFilter}
            header={<CustomDataTableHeader onChange={setGlobalFilter} />}
            emptyMessage="Nenhum usuário elegível encontrado"
          >
            <Column field="name" header="Nome" style={{ width: '30%' }} />
            <Column field="email" header="Email" style={{ width: '40%' }} />
            <Column field="operadores_logisticos" header="Operadores Logísticos" style={{ width: '30%' }} />
          </DataTable>
        )}
      </CustomModal>

      <ConfirmDialog
        className="ConfirmDialog-compact-actions"
        title="Confirmação"
        isVisible={showConfirm}
        content={`Tem certeza que deseja cadastrar o usuário ${selectedUser ? selectedUser.name : ''} como Analista de Entregas?`}
        onOk={handleConfirmYes}
        onCancelar={handleConfirmNo}
        disabled={isSaving}
      />
    </React.Fragment>
  )
}

export default ModalCadastrarAnalista
